export default "skymp5-front/ef92c2ecafd152e547c2f9296ce6956a.svg";